import { query, getPreloaderFnContext } from '@confluence/query-preloader-tools';
import { AccessStatus } from '@confluence/session-data';

import {
	EDITION_AWARENESS_STANDARD_TO_PREMIUM_EXPERIMENT_PILL_DISMISSED,
	useConfluenceStandardToPremiumExperimentQuery,
} from './useConfluenceStandardToPremiumExperiment';

export async function preloadUseConfluenceStandardToPremiumExperimentQuery() {
	const { isLoggedIn, accessStatus } = await getPreloaderFnContext();

	const isLicensed =
		accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS ||
		accessStatus === AccessStatus.LICENSED_USE_ACCESS;

	if (!isLoggedIn || !isLicensed) {
		return;
	}

	return query({
		query: useConfluenceStandardToPremiumExperimentQuery,
		variables: {
			key: EDITION_AWARENESS_STANDARD_TO_PREMIUM_EXPERIMENT_PILL_DISMISSED,
		},
	});
}
